




















































import { Component, Mixins } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { StoreModule } from "@/store/types";
import { OrderGetters, OrderActions } from "@/store/modules/order/types";
import { Order } from "@/models/order/order";
import { Mobile } from "@/mixins/mobile";
import { CreatedType } from "@/models/order/helpers";
import EditMultiplier from "@/components/elements/utility/EditMultiplier.vue";
@Component({ components: { EditMultiplier } })
export default class OrderSummary extends Mixins(Mobile) {
  @(namespace(StoreModule.Order).Getter(OrderGetters.GetOrder))
  storeOrder!: Order;
  @(namespace(StoreModule.Order).Action(OrderActions.ClearCreatedType))
  clearCreatedType!: () => Promise<void>;

  async created() {
    if (this.storeOrder.created_type === CreatedType.Duplicated) {
      await this.clearCreatedType();
    }
  }

  get surchargeDecimal(): number {
    const num = parseFloat(process.env.VUE_APP_PRICE_SURCHARGE_VALUE_NUMBER || "");
    return !isNaN(num) && num > 0 ? num : 0;
  }

  get surchargeLabel(): string {
    if (this.surchargeDecimal <= 0) return "";
    return `${+(this.surchargeDecimal * 100).toFixed(2)}%`;
  }

  get surchargePercent(): number {
    return this.surchargeDecimal > 0 ? this.surchargeDecimal * 100 : 0;
  }

  get price(): number {
    let price = 0;
    for (const item of this.storeOrder.items!) {
      price += item.qty * (item.unit_price * item.multiplier);
    }
    return price;
  }

  get surchargeAmount(): number {
    if (this.surchargePercent <= 0) return 0;
    return parseFloat((this.price * this.surchargePercent / 100).toFixed(2));
  }

  get totalPrice(): number {
    return this.price + this.surchargeAmount;
  }

  get totalQty(): number {
    let qty = 0;
    if (this.storeOrder.items && this.storeOrder.items.length) {
      for (const item of this.storeOrder.items) {
        qty += item.qty;
      }
    }
    return qty;
  }

  get isReviewPage(): boolean {
    return this.$route.name === "OrderReview";
  }
}
